<script setup lang="ts"></script>

<template>
  <div class="progress-wrapper">
    <div class="progress">
      <div class="progress__circle">1</div>
      <div class="progress__line"></div>
      <div class="progress__circle">2</div>
      <div class="progress__line"></div>
      <div class="progress__circle progress__circle_disabled">3</div>
    </div>
    <div class="progress__text">
      <p>Корзина</p>
      <p>Оформление заказа</p>
      <p>Заказ принят</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.progress-wrapper {
  width: fit-content;
  min-width: 460px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @include h4-8;
}
.progress {
  display: flex;
  align-items: center;
  color: $white;
  width: 100%;
  max-width: 460px;

  &__circle {
    padding: 8px 12px;
    background-color: $primary-green;
    border-radius: 50%;

    &_disabled {
      background-color: $ui-gray-2;
      color: $sub-text;
    }
  }

  &__line {
    height: 2px;
    background-color: $primary-green;
    width: 100%;
  }

  &__text {
    display: flex;
    width: 100%;
    max-width: 460px;
    justify-content: space-between;

    :nth-child(1) {
      color: $primary-text;
    }

    :nth-child(2) {
      color: $primary-green;
    }

    :nth-child(3) {
      color: $sub-text;
    }
  }
}
</style>
